import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 这里为什么不导出一个router实例哪？
// 每次用户请求都需要创建router实例
export default function createrouter() {
	return new Router({
		mode: 'history',
		routes: [
			{
			path: '/',
			component: () => import('@/views/index'),
			meta:{keepAlive: false} // 这个组件不需要缓存false,不缓存的话，刷新就会消失
			},
			{
			path: '/profile',
			component: () => import('@/views/company/profile'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/dynamic',
			component: () => import('@/views/company/dynamic'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/contact',
			component: () => import('@/views/company/contact'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/cooperate',
			component: () => import('@/views/cooperate/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Sterilization-robot',
			component: () => import('@/views/product/srt/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/aftersale',
			component: () => import('@/views/aftersale/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Companion-robot',
			component: () => import('@/views/product/accompany'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Receptionist-robot',
			component: () => import('@/views/product/welcome'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Food-delivery-robot',
			component: () => import('@/views/product/fooddelivery'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/buy',
			component: () => import('@/views/cooperate/buy'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/UVC-robot',
			component: () => import('@/views/product/uvc'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/dynamic_details',
			component: () => import('@/views/company/dynamic_details'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/regist',
			component: () => import('@/views/regist/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/technology',
			component: () => import('@/views/company/technology'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Sterilizer',
			component: () => import('@/views/product/homedisinfector'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/mobile',
			component: () => import('@/views/index1'),
			meta:{keepAlive: false} // 这个组件不需要缓存false,不缓存的话，刷新就会消失
			},
			{
			path: '/profile1',
			component: () => import('@/views/company1/profile'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/dynamic1',
			component: () => import('@/views/company1/dynamic'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/contact1',
			component: () => import('@/views/company1/contact'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/cooperate1',
			component: () => import('@/views/cooperate1/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Sterilization-robot1',
			component: () => import('@/views/product1/srt/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/aftersale1',
			component: () => import('@/views/aftersale1/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Companion-robot1',
			component: () => import('@/views/product1/accompany'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Receptionist-robot1',
			component: () => import('@/views/product1/welcome'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Food-delivery-robot1',
			component: () => import('@/views/product1/fooddelivery'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/buy1',
			component: () => import('@/views/cooperate1/buy'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/UVC-robot1',
			component: () => import('@/views/product1/uvc'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/dynamic_details1',
			component: () => import('@/views/company1/dynamic_details'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/regist1',
			component: () => import('@/views/regist1/'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/technology1',
			component: () => import('@/views/company1/technology'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
			{
			path: '/Sterilizer1',
			component: () => import('@/views/product1/homedisinfector'),
			meta:{keepAlive: false} // 这个组件不需要缓存false
			},
		]
	})
}